import {useFulfillmentDetailState} from '@/components/global/providers/FulfillmentDetailStateProvider';
import {useStoreNextRouter} from '@/components/global/providers/StoreNextRouter';
import useMediaQuery from '@/hooks/useMediaQuery';
import useOrderingExperience from '@/hooks/useOrderingExperience';
import {appBarMedia} from '@/styles/appBarMq';

const useEventBarCoachmarkVisible = (): boolean => {
  const {dismissCoachmark} = useFulfillmentDetailState();
  const {
    isOnBrandListPage,
    isOnCuisineMetroPage,
    isOnLoggedOutLandingPage,
    isOnMenuPage,
    isOnMetroPage,
    isOnOrderConfirmationPage,
    isOnSearchPage,
  } = useStoreNextRouter();
  const {isEater, isEzOrdering} = useOrderingExperience();
  const isAppBarLg = useMediaQuery(appBarMedia.lg);

  const eventBarRendered =
    !isEater &&
    !isEzOrdering &&
    !isOnLoggedOutLandingPage &&
    !isOnCuisineMetroPage &&
    !isOnMetroPage &&
    !isOnBrandListPage;

  const coachmarkAppliesToView =
    isAppBarLg && !isOnMenuPage && !isOnOrderConfirmationPage && !isOnSearchPage;

  return eventBarRendered && coachmarkAppliesToView && !dismissCoachmark;
};

export default useEventBarCoachmarkVisible;
